module.exports = __webpack_public_path__ + "mid-chat-reply-icon.png?15cdee3cf010aa29a1af2c282dfbc4e4";